<a [routerLink]="path" routerLinkActive="active">
  <pcs-icon title="{{link.label | translate}}" icon="{{link.icon}}" size="{{link.iconSize}}"></pcs-icon>
  <span *ngIf="hasLabel()" class="nav-item-link ms-2">{{link.label | translate}}</span>
  <span class="nav-item-badge" *ngIf="link.badge" [ngClass]="badgeClass">{{link.badge}}</span>
</a>
